import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { MailRequest, MailRequestEx } from '../models/mailRequest';
import { WhatsappRequest } from '../models/whatsappRequest';

@Component({
  selector: 'app-whatsapp-progress',
  templateUrl: './whatsapp-progress.component.html',
  styleUrls: ['./whatsapp-progress.component.scss']
})
export class WhatsappProgressComponent implements OnInit {

  private req : WhatsappRequest;
  public errMessage: string;
  constructor(private data: DataService, private router: Router, private location: Location) { }

  ngOnInit(): void {
    this.req = this.data.WhatsappReq;
    this.errMessage = "Sending message, please wait...."
    this.SendWhatsapp();
  }

  SendWhatsapp(): void {
    this.data.request<string>("kiosk/whatsapprequest",this.req,"POST").subscribe((e)=>{
      this.location.back();
    },(error)=>{
      this.errMessage = "Failed to send the message, please try again";
      console.error(error);
      this.delay(3000).then((v) => {
        this.location.back();
      })
    })
  }

 delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }


}




